import { LogoutOutlined, UserOutlined } from "@ant-design/icons"
import { Auth } from "../../utils/Auth"
import { authApi } from "../../api/authApi"
import { message, Select } from "antd"
import { useNavigate } from "react-router-dom"
import { useDevise } from "../../contexts/DeviseContext"

const TopbarLayout = (props) => {
  const user = Auth.getUser()
  const { devises, selectedDevise, selectDevise } = useDevise()

    return (
        <header className="flex items-center justify-between p-4 bg-africasa-secondary shadow-lg ">
          <button
            onClick={() => props.setSidebarOpen(!props.sidebarOpen)}
            className="p-2 text-africasa-primary  rounded-md focus:outline-none focus:bg-gray-300"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 6h16M4 12h16M4 18h16"
              ></path>
            </svg>
          </button>
          {/* <h1 className="text-xl font-semibold">Dashboard</h1> */}

          <div className="flex items-center space-x-4">
            {devises.length > 0 && (
              <Select
                size="small"
                value={selectedDevise?.id}
                style={{ width: 100 }}
                options={devises.map((d) => ({ value: d.id, label: d.iso_code }))}
                onChange={(value) => selectDevise(devises.find((d) => d.id === value))}
              />
            )}
            <span className="text-gray-100 font-medium"><UserOutlined /> {user?.user?.name}</span>
          <button className="text-gray-100 font-medium bg-transparent" onClick={props.handleLogout}><LogoutOutlined /> Deconnexion</button>

          </div>



        </header>
    )
}

export default TopbarLayout